import { getGlobalVariable } from '@/app/editor/config/globalVariable';

(function (jQuery) {
  jQuery.gfOptions = function (element, options) {
    const defaults = {
      targetElement: undefined,
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    let optionValue;
    const _this = this;

    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
    const $gryffBody = getGlobalVariable('gryffBody');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      // Render json;
      _this.refresh();

      return false;
    };

    this.getJsonData = function () {
      var value = $element.attr('value').trim();
      const arrayValue = value.split('\n');
      const arrayItem = [];
      for (let i = 0; i < arrayValue.length; i++) {
        var value = arrayValue[i].split('=>')[0].trim();
        const label = arrayValue[i].split('=>')[1].trim();
        const item = {
          label: {
            name: 'label',
            class: '',
            caption: 'Label',
            type: 'text',
            default_value: label,
          },
          value: {
            name: 'value',
            class: '',
            caption: 'Value',
            type: 'text',
            default_value: value,
          },
        };
        arrayItem.push(item);
      }
      const items = {
        items: arrayItem,
      };
      return items;
    };

    this.refresh = function () {
      if ($element.next('.gfoptions').length > 0) {
        $element.next('.gfoptions').remove();
        optionValue = undefined;
      }
      const items = _this.getJsonData();
      optionValue = JSON.stringify(items);

      const $divRepeator = jQuery('<div class="repeator container gfoptions" data-caption=""></div>');
      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);

      $element.after($divRepeator);
      $divRepeator.gfRepeator({
        targetElement: $targetElement,
        dataHolder: optionValue,
        render: true,
        detectChange: function (dataChanged) {
          optionValue = dataChanged;
          _this.saveOption(JSON.parse(dataChanged));
        },
      });

      // EVENT;
      let delay;
      $divRepeator.find('input').on('input-change', function () {
        const $that = $(this);
        clearTimeout(delay);
        delay = setTimeout(function () {
          const $li = $that.parents('.item');
          const index = $li.attr('index');

          const json = JSON.parse(optionValue);
          json['items'][index][$that.attr('name')].default_value = $that.attr('value');
          optionValue = JSON.stringify(json);

          _this.saveOption();
        }, 100);
      });
    };

    this.saveOption = function (jsonData) {
      let json;
      if (jsonData != undefined) {
        json = jsonData;
      } else {
        json = JSON.parse(optionValue);
      }
      const items = json['items'];
      let string = '';
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const value = item['value'].default_value;
        const label = item['label'].default_value;

        string += value + ' => ' + label + '\n';
      }
      $element.attr('value', string).val(string).trigger('input-change');
      return false;
    };

    this.init();
  };

  jQuery.fn.gfOptions = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfoptions')) {
        const plugin = new jQuery.gfOptions(this, options);
        jQuery(this).data('gfoptions', plugin);
      }
    });
  };
})(jQuery);
